import styled from 'styled-components';
import { STACK_AT } from './components/AssetVerificationDocumentPanel/styles';

export const FlowLayout = styled.div`
  display: flex;
  gap: 1rem;

  /* Below the panel's stack breakpoint the PDF viewer and the form panel
     stack instead of fighting for width. */
  @media (max-width: ${STACK_AT}) {
    flex-wrap: wrap;
  }
`;

export const FooterBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.5rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid ${({ theme }) => theme.color.gray[200]};
  margin-top: 1rem;
`;
